export const RESTAURANT_STATUSES = [
  { value: 'backlog', label: 'Backlog', color: 'bg-gray-100 text-gray-700', dot: '#6B7280' },
  { value: 'negotiations', label: 'Negotiations', color: 'bg-blue-100 text-blue-700', dot: '#2563EB' },
  { value: 'trial', label: 'Trial', color: 'bg-yellow-100 text-yellow-700', dot: '#D97706' },
  { value: 'paying', label: 'Paying', color: 'bg-green-100 text-green-700', dot: '#059669' },
];

export const RESTAURANT_STATUS_MAP = Object.fromEntries(RESTAURANT_STATUSES.map(s => [s.value, s]));

export const RT_STATUSES = [
  { value: 'todo', label: 'To Do' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'waiting', label: 'Waiting' },
  { value: 'done', label: 'Done' },
];

export const RT_TYPES = [
  { value: 'negotiations', label: 'Negotiations', color: '#2563EB' },
  { value: 'documents', label: 'Documents', color: '#7C3AED' },
  { value: 'contracts', label: 'Contracts', color: '#0891B2' },
  { value: 'trial', label: 'Trial', color: '#D97706' },
  { value: 'migration', label: 'Migration', color: '#DB2777' },
  { value: 'onboarding', label: 'Onboarding', color: '#059669' },
  { value: 'qa', label: 'QA', color: '#DC2626' },
];

export const RT_TYPE_MAP = Object.fromEntries(RT_TYPES.map(t => [t.value, t]));
